<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16YWCSx/tc-custom/9781591811442.jpg?1704585987196" alt="This image is the cover for the book Underachieving School"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Underachieving School
      </h1>
      <p class="bookDescription body article font2">
        <p>The Underachieving School is a collection of essays and articles written and compiled by Holt, each brimming with inspiration and ideas on how to teach children—taking into account the ways in which children actually learn. Through his original thinking, clear and thoughtful writing, and firsthand accounts of what does and doesn’t work in education, this book shows us the difference between learning and schooling.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Holt
      </h2>
      
      <p class="authorDescription body article">John Holt was a fifth grade teacher who worked in private schools. In 1964, his book How Children Fail created an uproar with his observations that forcing children to learn makes them unnaturally self-conscious about learning and stifles children’s initiative and creativity by making them focus on how to please the teachers and the schools with the answers they will reward best. His subsequent book, How Children Learn (1967), also became widely known. The two are still in print and together they have sold over a million and a half copies and have been translated into over 14 languages.  Holt went on to become a visiting lecturer at Harvard and Berkeley, but his tenure at both places was short-lived. Holt did not feel the school establishment was serious about change in the ways he wanted to go, such as changing the relationship of the child to the teacher and the school to the community. In 1985, John Holt died of cancer at the age of 62, having written 10 books that were very influential in the development of the homeschooling and unschooling movements.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sentient Publications
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?526de7ea